<template>
	<div class="content">
		<h1 class="content__title">Ставка {{ bidResult === 'win' ? 'выиграла' : 'проиграла' }}</h1>
		<div class="content__inner">
			<div class="result">
				<div class="result__tumbnail">
					<img src="../assets/icons/icon-successful-check.jpg" v-if="bidResult === 'win'">
					<img src="../assets/icons/icon-failed.jpg" v-else>
				</div>
				<p>{{ bidResult === 'win' ? 'Поздравляем! Ваша ставка выиграла.' : 'Ваша ставка проиграла.' }}</p>
				<p>Сумма {{ bidResult === 'win' ? 'выигрыша' : 'проигрыша' }} по обновленному курсу:
					<span>{{convertedAmount}} ВТС</span>
				</p>
				<a class="result__add-new btn" href="#" @click="newBid">Сделать еще ставку</a>
			</div>
		</div>
		<ContentFooter/>
	</div>
</template>

<script>
	import ContentFooter from "./ContentFooter";
	import {mapState} from 'vuex'

	export default {
		name:       "Modal",
		components: {ContentFooter},
		computed:   {
			...mapState({
				convertedAmount: state => state.indexes.convertedAmount,
				bidResult: state => state.indexes.bidResult
			})
		},
		methods:    {
			newBid: function () {
				this.$store.dispatch('indexes/newBid')
			}
		}
	}
</script>
